import * as api from "./../../api/index";
import * as ActionTypes from "./../ActionTypes";

export const search = (user) => async (dispatch) => {
    try {
        const { data } = await api.search(user);

        dispatch({
            type: ActionTypes.SEARCH,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}